/**
 * 支付方式类型
 */
export enum PaymentMethodType {
  CARD = 'Card',
  GOOGLE_PAY = 'GooglePay',
  APPLE_PAY = 'ApplePay',
}
